import { ChangeEvent, FC, useState } from "react";
import { useDispatch } from "react-redux";

import { changeLimitsSettings } from "./../../../../store/settings/actionCreators";
import { IFormSettings } from "./../../../../services/forms";
import LimitSelect from "./../../General/GeneralSelect";
import Switch from "./../../../../libs/Switch";

import styles from "./styles.module.scss";

interface IProps {
    limitSettings: IFormSettings["limits"];
}

const SubmissionSection: FC<IProps> = ({ limitSettings }) => {
    const dispatch = useDispatch();
    const [submissionWarning, setSubmissionWarning] = useState<string>(
        limitSettings.formAvailability.disableBy.submission.warning,
    );
    const [subNum, setSubNum] = useState<number>(limitSettings.formAvailability.disableBy.submission.submissionsNumber);

    const [limitPeriodValue, setLimitPeriodValue] = useState<number>(
        +limitSettings.formAvailability.disableBy.submission.limitMonths,
    );
    const [limitPeriod, setLimitPeriod] = useState<string>(
        limitSettings.formAvailability.disableBy.submission.limitPeriod,
    );

    const getSubmissionWarningMessage = (e: ChangeEvent<HTMLInputElement>) => {
        setSubmissionWarning(e.target.value);
    };
    const getSubmissionNumber = (e: ChangeEvent<HTMLInputElement>) => {
        +e.target.value >= 0 && setSubNum(+e.target.value);
    };
    const getYearLimitNumber = (e: ChangeEvent<HTMLInputElement>) => {
        +e.target.value >= 0 && setLimitPeriodValue(+e.target.value);
    };

    const handleStateUpdate = (element: any) => {
        dispatch(
            changeLimitsSettings({
                prevState: limitSettings,
                currentState: {
                    formAvailability: {
                        ...limitSettings.formAvailability,
                        ...element,
                    },
                },
            }),
        );
    };

    return (
        <div className={styles.disableBySubmissionQuantity}>
            <label>
                <Switch
                    checked={limitSettings.formAvailability.disableBy.submission.isActive}
                    onChange={() =>
                        handleStateUpdate({
                            disableBy: {
                                ...limitSettings.formAvailability.disableBy,
                                submission: {
                                    ...limitSettings.formAvailability.disableBy.submission,
                                    isActive: !limitSettings.formAvailability.disableBy.submission.isActive,
                                    startDate: new Date().toISOString().split("T")[0],
                                },
                            },
                        })
                    }
                />
                <p className={styles.subTitle}> Submission Quantity</p>
            </label>

            {limitSettings.formAvailability.disableBy.submission.isActive && (
                <>
                    <div className={styles.limitsBox}>
                        <label className={styles.listenLabel}>
                            Submissions Amount
                            <input
                                type={"number"}
                                value={subNum ? subNum : ""}
                                placeholder={"0"}
                                onChange={e => getSubmissionNumber(e)}
                                className={styles.customInput}
                                onBlur={() =>
                                    handleStateUpdate({
                                        disableBy: {
                                            ...limitSettings.formAvailability.disableBy,
                                            submission: {
                                                ...limitSettings.formAvailability.disableBy.submission,
                                                submissionsNumber: subNum,
                                            },
                                        },
                                    })
                                }
                            />
                        </label>
                        <label className={styles.listenLabel}>
                            Limit Period
                            <LimitSelect
                                isLimit
                                selectedItem={limitPeriod}
                                setState={(newKey: string) => {
                                    setLimitPeriod(newKey);

                                    handleStateUpdate({
                                        disableBy: {
                                            ...limitSettings.formAvailability.disableBy,
                                            submission: {
                                                ...limitSettings.formAvailability.disableBy.submission,
                                                limitPeriod: newKey,
                                            },
                                        },
                                    });
                                }}
                                options={{ Day: "Day", Week: "Week", Month: "Month", Year: "Year" }}
                            />
                        </label>

                        <label className={styles.listenLabel}>
                            Limit per {limitPeriodValue} {limitPeriod}
                            <input
                                type={"number"}
                                value={limitPeriodValue ? limitPeriodValue : ""}
                                onChange={e => getYearLimitNumber(e)}
                                className={styles.customInput}
                                onBlur={() =>
                                    handleStateUpdate({
                                        disableBy: {
                                            ...limitSettings.formAvailability.disableBy,
                                            submission: {
                                                ...limitSettings.formAvailability.disableBy.submission,
                                                limitMonths: limitPeriodValue,
                                            },
                                        },
                                    })
                                }
                            />
                        </label>
                    </div>
                    <label className={styles.listenLabel}>Start</label>
                    <input
                        type={"date"}
                        max={limitSettings.formAvailability.disableBy.date.endDate}
                        value={limitSettings.formAvailability.disableBy.submission.startDate}
                        className={styles.customInput}
                        onChange={e =>
                            handleStateUpdate({
                                disableBy: {
                                    ...limitSettings.formAvailability.disableBy,
                                    submission: {
                                        ...limitSettings.formAvailability.disableBy.submission,
                                        startDate: e.target.value,
                                    },
                                },
                            })
                        }
                    />
                    <label className={styles.warningSection}>
                        Warning Message
                        <input
                            type="text"
                            value={submissionWarning}
                            onChange={e => getSubmissionWarningMessage(e)}
                            className={styles.customInput}
                            onBlur={() =>
                                handleStateUpdate({
                                    disableBy: {
                                        ...limitSettings.formAvailability.disableBy,
                                        submission: {
                                            ...limitSettings.formAvailability.disableBy.submission,
                                            warning: submissionWarning,
                                        },
                                    },
                                })
                            }
                        />
                    </label>
                </>
            )}
        </div>
    );
};

export default SubmissionSection;
